import moment from "moment-timezone";
import {FaWhatsapp} from "react-icons/fa";
import {FaMobileScreenButton} from "react-icons/fa6";

const getIcon = (type) => {
  switch (type) {
    case "call":
      return <FaMobileScreenButton />;
    case "whatsapp":
      return <FaWhatsapp />;
    default:
      return <FaMobileScreenButton />;
  }
};

const JourneyItem = ({journey}) => (
  <div className="flex items-center p-2 border-l-2 border-[#2ba9cd] ml-2">
    <div className="text-[#2ba9cd] text-xl">
      {getIcon(journey.channel ? journey.channel : "call")}
    </div>
    <div className="flex flex-col ml-4">
      <p className="text-m font-semibold text-gray-600">
        {moment
          .tz(new Date(journey.start_time), process.env.REACT_APP_TIMEZONE)
          .format("hh:mm:ss A")}
      </p>
      <p className="text-sm text-gray-400">
        {moment
          .tz(new Date(journey.start_time), process.env.REACT_APP_TIMEZONE)
          .format("Do MMM YYYY")}
      </p>
    </div>
  </div>
);

export default JourneyItem;
